import React from 'react';
import {useSelector} from 'react-redux';
import BACSidebar from './BACSidebar';
import OrgSidebar from './OrgSidebar';

const SITE_ROLES = ['site-admin', 'site-user', 'site-guest'];

const SideMenu = ({ isOpen, toggle, organization = null }) => {
    const { user } = useSelector((state) => state.auth);

    if (!user) {
        return;
    }

    return SITE_ROLES.includes(user.role) ? (
        <OrgSidebar isOpen={isOpen} toggle={toggle} organization={organization} />
    ) : (
        <BACSidebar isOpen={isOpen} toggle={toggle} organization={organization} />
    );
};

export default SideMenu;
